module.exports = {
  getItemPostedTime: function (timeStamp) {
    const timest = '2022-10-05T07:04:24.000Z';
    const todayDate = '06-12-2022';
    const date = new Date();
    // const todayDate = String(date.getDate()).padStart(2, '0')+"-"+String(date.getMonth() + 1).padStart(2, '0')+"-"+ date.getFullYear();

    // CREATED TIME
    const crDate = Number(timest?.slice(8, 10));
    const crMonth = Number(timest?.slice(5, 7));
    const crYear = Number(timest?.slice(0, 4));

    //CURRENT TIME
    const curDate = Number(todayDate?.slice(0, 2));
    const curMonth = Number(todayDate?.slice(3, 5));
    const curYear = Number(todayDate?.slice(6, 10));

    console.log('timeStamp2', todayDate, timeStamp);
    console.log('timeStamp56', curMonth - crMonth);

    if (curDate === crDate && crMonth === curMonth && crYear === curYear) {
      return 'Today';
    } else if (
      curDate - crDate === 1 &&
      crMonth === curMonth &&
      crYear === curYear
    ) {
      return 'Yesterday';
    } else if (
      (curMonth - crMonth === 1 || curMonth - crMonth === -11) &&
      (crYear === curYear || curYear - crYear === 1)
    ) {
      return 'Last Month';
    } else if (
      (curMonth - crMonth === 2 || curMonth - crMonth === -10) &&
      (crYear === curYear || curYear - crYear === 1)
    ) {
      return '2 Months ago';
    } else if (
      ((curMonth - crMonth >= 3 && curMonth - crMonth <= 5) ||
        (curMonth - crMonth >= -9 && curMonth - crMonth <= -6)) &&
      (crYear === curYear || curYear - crYear === 1)
    ) {
      return '3 Months ago';
    } else if (
      (curMonth - crMonth === 6 ||
        (curMonth - crMonth >= -5 && curMonth - crMonth <= -1)) &&
      (crYear === curYear || curYear - crYear === 1)
    ) {
      return '6 Months ago';
    } else if (
      curYear - crYear === 1 &&
      (curMonth - crMonth === 0 ||
        curMonth - crMonth === 1 ||
        curMonth - crMonth === 2 ||
        curMonth - crMonth === 3 ||
        curMonth - crMonth === 4 ||
        curMonth - crMonth === 5 ||
        curMonth - crMonth === 6 ||
        curMonth - crMonth === 7 ||
        curMonth - crMonth === 8 ||
        curMonth - crMonth === 9 ||
        curMonth - crMonth === 10 ||
        curMonth - crMonth === 11)
    ) {
      return '1 Year ago';
    } else if (curYear - crYear === 2) {
      return '2 Year ago';
    } else if (curYear - crYear === 3) {
      return '3 Year ago';
    } else if (curYear - crYear === 4) {
      return '4 Year ago';
    } else if (curYear - crYear >= 5) {
      return 'More then 5 Year ago';
    }
  },
};
